<template>
    <div class="filter flex relative w-full" :class="{'padding-none': !isActions}">
        <div class="buttons flex z-10" v-if="isActions">
            <slot name="actions" />
            <div class="p-3 cursor-pointer" @click="activeFilters = !activeFilters" v-if="hideBtn">
                <vs-icon v-tooltip="activeFilters ? $t('tooltip.Show') : $t('tooltip.Hide')" v-bind="$iconData('icon-chevron-down', 'fi-rr-angle-down')"/>
            </div>
            <div :class="{disabled}" class="p-3 cursor-pointer" @click="$emit('refresh')">
                <vs-icon v-tooltip="$t('tooltip.Reset_filter')" v-bind="$iconData('icon-rotate-cw', 'fi-rr-rotate-right')"/>
            </div>
        </div>

        <div class="w-full" :class="{activeFilters: activeFilters}">
            <div v-if="isActions" class="filter__header mb-4">{{ $t('global.Filters') }}</div>
            <div class="filter__container">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isActions: {
            type: Boolean,
            default: true
        },

        isPadding: {
            type: Boolean,
            default: true
        },

        disabled: {
            type: Boolean,
            default: false
        },

        hideBtn: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            activeFilters: false
        }
    }
}
</script>

<style lang="scss">
.filter {
    background: #ffffff;
    padding: 20px;
    border-radius: 0.5rem;
    margin-bottom: 15px;

    &.padding-none {
        padding: 0 !important;
        margin-bottom: 0;
    }

    .disabled {
        opacity: .5;
        cursor: default;
        pointer-events: none;
    }

    &__header {
        font-size: 17px;
        font-size: 19px;
        line-height: 17px;
        color: #000000;

    }

    &__container {
        height: auto;
        transition: all .25s ease;
    }

    &__nopr:nth-child(7n) {
        padding-right: 0 !important;
    }
}

.activeFilters {
    .filter {
        &__header {
            margin-bottom: 0 !important;
        }

        &__container {
            height: 0;
            transition: all .25s ease;
            overflow: hidden;
        }
    }
}


.buttons {
    position: absolute;
    top: 0;
    right: 0;
}

//&__buttons {
//    width: 100%;
//
//    button {
//        margin-bottom: 0 !important;
//    }
//}

.content-tr-expand {
    justify-content: left !important;
}
</style>
